import { ServicesFiltersEnum } from '@/enums'
import { defineStore } from 'pinia'
import i18n from '@/i18n'

export const useSearchFiltersStore = defineStore('searchFilters', {
  state: () => ({
    isOpen: true as boolean,
    filtersToApply: [] as any[],
    withoutFeesFilter: null as boolean,
    withFeesFilter: null as boolean,
    withoutAvailsFilter: false as boolean,
    withTa7AvailsFilter: false as boolean,
    withT07AvailsFilter: false as boolean,
    withPharmacy: false as boolean,
    withPrivateClinic: false as boolean,
    withHealthEstablishment: false as boolean,
    mobile: {
      withoutFeesFilter: null as boolean,
      withFeesFilter: null as boolean,
      withoutAvailsFilter: false as boolean,
      withTa7AvailsFilter: false as boolean,
      withT07AvailsFilter: false as boolean,
      withPharmacy: false as boolean,
      withPrivateClinic: false as boolean,
      withHealthEstablishment: false as boolean
    }
  }),
  getters: {
    getfiltersList: () => {
      const { t } = i18n.global
      return [
        {
          title: t(`base.pageTitle.withWithoutFees`),
          id: ServicesFiltersEnum.WITH_WITHOUT_FEES
        },
        {
          title: t(`base.pageTitle.withoutFees`),
          id: ServicesFiltersEnum.WITHOUT_FEES
        }
      ]
    }
  },
  actions: {
    getPricingFilter(): { title: string; id: string } {
      const { withoutFeesFilter, withFeesFilter } = this

      if (withFeesFilter === null || withoutFeesFilter === null) {
        return null
      }

      return this.getPricingFilterTitle({ withFeesFilter, withoutFeesFilter })
    },
    getPricingFilterMobile(): { title: string; id: string } {
      const { withoutFeesFilter, withFeesFilter } = this.mobile
      if (withFeesFilter === null || withoutFeesFilter === null) {
        return null
      }

      return this.getPricingFilterTitle({ withFeesFilter, withoutFeesFilter })
    },
    getPricingFilterTitle({ withFeesFilter, withoutFeesFilter }): { title: string; id: string } {
      return withFeesFilter && withoutFeesFilter ? this.getfiltersList[0] : this.getfiltersList[1]
    }
  }
})
